import type { ReactElement } from 'react';

import { UnsavedChangesScopeEnum } from '../../enums/UnsavedChangesScopeEnum';
import { useRegisterUnsavedChanges } from '../../hooks/useRegisterUnsavedChanges';
import { useSettingSave } from '../../hooks/useSettingSave';

/**
 * Registers settings save-card dirty state with the global unsaved-changes guard.
 */
export function SettingUnsavedChangesRegistration(): ReactElement | null {
  const { isDirty, discardChanges } = useSettingSave();

  useRegisterUnsavedChanges({
    isDirty,
    onDiscard: discardChanges,
    scope: UnsavedChangesScopeEnum.Settings,
  });

  return null;
}
